module.exports = __webpack_public_path__ + "img/123-eryaxindahei-d15.fe61eb0e.png";